import * as React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { FormControl, Grid, MenuItem, Select } from "@mui/material"
import { useDispatch } from "react-redux"
import { getSuscriberRefId } from "../../../../../app/services/Suscriber/getSuscriberFromRefId"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "../../../../../redux/actions/app"

import useStylesSeeDetailSuscriber from "./useStyleSeeDetailsSuscriber"
import CloseIcon from "@mui/icons-material/Close"
import { getSubscriberStatus } from "../../../../../redux/actions/Suscriber"
import ModalConfirmChange from "../../../../../components/Modals/Organizations/User/ModalConfirmChange/ModalConfirmChange"
import { updateSubscriberCorpEntities } from "../../../../../app/services/Suscriber/updateSubscriberCorpEntities"
import { helpGetOrganizationWithID } from "../../../../../app/services/Organization/helpGetOrganizationWithID"

export default function StepSeeDetailsSuscriber({
  item,
  setstateDetailsSuscriber,
  setLoading,
}) {
  const dispatch = useDispatch()
  const classes = useStylesSeeDetailSuscriber()
  const [suscriber, setsuscriber] = React.useState(null)
  const [statesSuscriber, setstatesSuscriber] = React.useState([])
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [selectedStatusId, setSelectedStatusId] = React.useState(null)
  const [organizationCuit, setOrganizationCUIT] = React.useState(null)
  React.useEffect(async () => {
    if (!suscriber) {
      setLoading(true)
      const getsuscriber = await handleGetSuscriber()
      if (getsuscriber !== "Error") {
        await handleGetNameStatusCode(getsuscriber.subscriber_status_id)
      }
      setLoading(false)
    }
  }, [])

  React.useEffect(() => {
    const loadOrganizationData = async () => {
      if (suscriber && suscriber.organization_id) {
        setLoading(true)
        await handleGetOrganizationWithID()
        setLoading(false)
      }
    }

    loadOrganizationData()
  }, [suscriber])
  // request get suscriber and set in state or error message
  const handleGetSuscriber = async () => {
    try {
      const params = {
        clicod: item.subscriber_ref_id,
      }
      const getsuscriber = await getSuscriberRefId(params)
      setsuscriber(getsuscriber.data)
      return getsuscriber
    } catch (err) {
      // error
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))
      return "Error"
    }
  }

  // return name of status suscriber with codeState
  const getName = (codeSuscriber) => {
    const state = statesSuscriber.filter(
      (x) => x.subscriber_status_id === codeSuscriber,
    )
    return state.length > 0 ? state[0].subscriber_status_desc : null
  }

  // request get and set status list or error message
  const handleGetNameStatusCode = async () => {
    const response = await dispatch(getSubscriberStatus())
    setstatesSuscriber(response)
  }

  // return date string of visual
  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        "/" +
        (newDate.getMonth() + 1) +
        "/" +
        newDate.getFullYear()
    } else {
      formattedDate = ""
    }
    return formattedDate
  }
  const handleOpenModalChangeStatus = (newStatusId) => {
    setSelectedStatusId(newStatusId)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedStatusId(null)
  }
  const handleGetOrganizationWithID = async () => {
    try {
      const response = await helpGetOrganizationWithID(
        suscriber.organization_id,
      )

      setOrganizationCUIT(response.data?.data)
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))
    }
  }

  const handleConfirmChangeStatus = async () => {
    if (!organizationCuit) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar("Error: Datos de organización no disponibles."),
      )
      return
    }
    handleCloseModal()
    setLoading(true)
    const subscriberId = suscriber.subscriber_id
    try {
      const requestBody = {
        clicod: suscriber.subscriber_ref_id ?? "",
        subscriber_name: suscriber.subscriber_name ?? "",
        organization_cuit: organizationCuit.organizationCuit ?? "",
        organization_legal_name: suscriber.organization_legal_name ?? "",
        subscriber_max_user_count: suscriber.subscriber_max_user_count ?? "",
        subscriber_status_id: selectedStatusId,
      }


      await updateSubscriberCorpEntities(subscriberId, requestBody)

      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar("Estado actualizado correctamente."))

      await handleGetSuscriber()
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar("Ocurrió un error al actualizar el estado."),
      )
    } finally {
      setLoading(false)
    }
  }
  const SeeMoreOrganizationOfID = () => {
    return (
      suscriber && (
        <>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Razón social:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.subscriber_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Numero de suscriptor:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.subscriber_ref_id}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Estado:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* <Typography className={classes.value}>
                {getName(suscriber.subscriber_status_id)
                  ? getName(suscriber.subscriber_status_id)
                  : "Error al cargar"}
              </Typography> */}
              <FormControl style={{ minWidth: 160 }} className={classes.value}>
                <Select
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                  }}
                  value={suscriber.subscriber_status_id}
                  onChange={(e) => handleOpenModalChangeStatus(e.target.value)}
                  renderValue={(selectedId) => {
                    if (!selectedId) {
                      return <span style={{ color: "#aaa" }}>- -</span>
                    }
                    return getName(selectedId)
                  }}
                >
                  {statesSuscriber.map((state) => (
                    <MenuItem
                      key={state.subscriber_status_id}
                      value={state.subscriber_status_id}
                    >
                      {state.subscriber_status_desc}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          {isModalOpen && (
            <ModalConfirmChange
              title="Confirmar cambio de estado"
              message={`¿Estás seguro de cambiar el estado del suscriptor?`}
              open={isModalOpen}
              onClose={handleCloseModal}
              onConfirm={handleConfirmChangeStatus}
            />
          )}

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Máximo de usuarios:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.subscriber_max_user_count}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Fecha de creación:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {formatDate(suscriber.creation_date)}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Usuario creador:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.creation_user}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Fecha de modificación:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {formatDate(suscriber.modification_date)
                  ? formatDate(suscriber.modification_date)
                  : "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Usuario modificador:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.modification_user
                  ? suscriber.modification_user
                  : "- -"}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                ID del suscriptor:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.subscriber_id}
              </Typography>
            </Grid>
          </Grid>
        </>
      )
    )
  }

  return (
    <>
      <Box className={classes.backgroundBox}>
        <div
          style={{
            width: "100%",
            display: "flex",
            padding: "8px 0px 8px 0px",
            justifyContent: "space-between",
            boxShadow: "0px 1px 1px #EAEAEA",
            color: "#8C8C8C",
          }}
        >
          <Typography className={classes.seeMoreTypography}>
            Información del suscriptor
          </Typography>
          <CloseIcon
            style={{
              cursor: "pointer",
              paddingRight: 10,
              fontSize: "1.5rem",
            }}
            onClick={() => {
              setstateDetailsSuscriber(false)
            }}
          />
        </div>
        <div className={classes.mainBox}>
          <SeeMoreOrganizationOfID />
        </div>
        <ButtonClose setstateDetailsSuscriber={setstateDetailsSuscriber} />
      </Box>
    </>
  )
}

function ButtonClose({ setstateDetailsSuscriber }) {
  return (
    <Box
      style={{
        position: "absolute",
        width: "95%",
        marginLeft: "5%",
        bottom: 20,
        display: "flex",
      }}
    >
      <Box
        sx={{
          width: 90,
          height: 35,
          backgroundColor: "#1C846F",
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.50)",
          WebkitBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.50)",
          MozBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.50)",
          borderRadius: 1,
          display: "flex",
          "&:hover": {
            bgcolor: "#1BF57F",
          },
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          onClick={() => {
            setstateDetailsSuscriber(false)
          }}
          sx={{
            color: "#FFFFFF",
            cursor: "pointer",
            fontSize: 16,
          }}
        >
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
